import req from '../req'

// 表单管理 - 表单模板列表
export function getTemplate (params) {
  return req.get('/forms/template/list', params)
}

// 表单管理 - 状态变更
export function changeTemplate (params) {
  return req.post('/forms/template/changeStatus', params)
}

// 表单管理 - 复制接口
export function copyTemplate (params) {
  return req.post('/forms/template/copy', params)
}

// 表单管理 - 渠道活码
export function fetchDynamicCode (params) {
  return req.get('/traffic/dynamic-code/list', params)
}
